<template>
	<div class="inner-page cases">
    
		<AppHead :title="['admin', 'global_viewer'].includes($page.props.user.user_type) ? `Non-distributor Cases` : `Other Cases`" />

		<PageHeader 
			:title="['admin', 'global_viewer'].includes($page.props.user.user_type) ? `Non-distributor Cases` : `Other Cases`"
			:desc="['admin', 'global_viewer'].includes($page.props.user.user_type) ? `These cases don't belong to a distributor.` : `Cases that I have been assigned to as an editor or viewer, or cases I own.`"
			:showHelper="false"
			/>


		<div class="cases-list" v-if="cases && cases.length > 0">
			<CaseOverviewRow 
				v-for="(theCase, index) in cases"
				:key="index"
				:thisCase="theCase"
				:caseID="theCase.hashid"
				:visibleCaseID="theCase.enquiry_number ? theCase.enquiry_number : theCase.hashid"
				:description="theCase.description"
				:steps="theCase.progress_stage"
				:commentCount="theCase.chat_count"
				:assignTeam="permissions.canAssignProjectToTeam"
				:assignManager="permissions.canAssignProjectManager"
				:allPotentialManagers="allPotentialManagers"
				:team="theCase.teams"
				:teams="allTeams"
				/>

		</div>
		<Placeholder v-else message="There are currently no active other Cases" />

	</div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Subtitle from "@/Components/Subtitle"
import Placeholder from "@/Components/Placeholder"
import CaseOverviewRow from "@/Components/Cases/CaseOverviewRow"

export default {
	components: {
		AppLayout,
    AppHead,
    PageHeader,
    Subtitle,
    Placeholder,
    CaseOverviewRow
	},
	layout: AppLayout,
  props: [
    'cases',
    'permissions',
    'allPotentialManagers',
		'allTeams'
  ],
  methods: {
    
  },
  mounted(){
    // console.log(this.cases)
  }
};
</script>